import { Center, Spinner, useToast } from "@chakra-ui/react";
import { AuthenticatedUser } from "@intentsify/types";
import { useMutation } from "@tanstack/react-query";
import { apiService, Endpoints } from "api";
import { getPostLoginRoute } from "auth/auth.utils";
import { consumeOAuthReturnPath } from "auth/oauthReturnPath";
import { LoginScreenDefinition } from "auth/screens/Login/Login.definition";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAppStore } from "store/useAppStore";

const SsoCallback = () => {
  const setUser = useAppStore.use.setUser();
  const navigate = useNavigate();
  const toast = useToast();

  const { mutate } = useMutation(
    () =>
      apiService
        .get<AuthenticatedUser>(Endpoints.Auth.Get.Me)
        .then((r) => r.data),
    {
      onSuccess: (user) => {
        setUser(user);
        if (user.isActive) {
          toast({ title: "Welcome!", status: "success" });
        } else {
          toast({
            title:
              "Before continuing you have to agree to the terms and conditions.",
            status: "info",
          });
        }
        navigate(
          getPostLoginRoute(
            user,
            user.isActive ? consumeOAuthReturnPath() : undefined,
          ),
          { replace: true },
        );
      },
      onError: () => {
        toast({
          title: "SSO login failed. Please try again.",
          status: "error",
          isClosable: true,
        });
        navigate(LoginScreenDefinition.navigate(), { replace: true });
      },
    },
  );

  useEffect(() => {
    mutate();
  }, [mutate]);

  return (
    <Center h="100vh">
      <Spinner size="xl" color="white" />
    </Center>
  );
};

export { SsoCallback };
